﻿import { useQuery } from 'react-query';

import TaskService from 'services/task.service';

export function useGetTasks(params, options) {
  return useQuery(['tasks', params], () => TaskService.get(params), options);
}
